import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import SpinnerLoader from "../../../Utils/Spinner";
import "../../../assets/css/StudentShortDetails.css"; // import your CSS
import { FeeApprovalsTemplateSucessFullModal } from "../../../Component/Modals/FeeApprovalsTemplateSuccessFullModal";
import TableSkeleton from "../../../Utils/TableSkeleton";
import { getData, Postdata } from "../../../API/GlobalApi";
import Notifier from "../../../Utils/notify";

const ImposeFeeApprovalsTemplateStudentWise = () => {
    const { uniqueId } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const signature = queryParams.get("signature");
    const user_id = queryParams.get("user_id")
    

    const navigate = useNavigate();
    const [feePlanData, setFeePlanData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [remark, setRemark] = useState("");
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
   


    const getFeePlanData = async () => {
        try {
            const params = new URLSearchParams();
            if (signature) params.append("signature", signature);
            if (user_id) params.append("user_id", user_id);

            // Construct final URL with signature & user_id
            const finalUrl = `finance/fee-schedules/status/${uniqueId}/?${params.toString()}`;
            

            const res = await getData(finalUrl);
            // const res = await getData(`finance/fee-schedules/status/${uniqueId}`);
            if (res && Array.isArray(res.students)) {
                const mappedData = {
                    specialization: { name: res?.course_name || "N/A" },
                    semester: { name: res?.semester_name || "N/A" },
                    created_by: res?.created_by || "N/A",
                    students: res.students.map((stu) => ({
                        id: stu.permanent_registration_number,
                        name: stu.student_name,
                        rollNumber: stu.permanent_registration_number,
                        payments:
                            Array.isArray(stu.fee_heads) && stu.fee_heads.length > 0
                                ? stu.fee_heads.map((fh) => ({
                                    fee_head_name: fh.name,
                                    amount: fh.amount,
                                }))
                                : [],
                    })),
                    total_amount: res?.summary?.total_amount_all_students || 0,
                    status: res?.status || "N/A",
                    created_on: res?.current_datetime || 'N/A',
                };

                setFeePlanData(mappedData);
            } else {
                console.warn("No students found in response");
                setFeePlanData(null);
            }
        } catch (error) {
            console.error("Error fetching fee plan data:", error);
            setFeePlanData(null);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        getFeePlanData()
    }, [uniqueId])




    if (loading) {
        return (
            <div className="container">
                <div className="d-flex justify-content-center align-items-center vh-100 text-muted">
                    <TableSkeleton />
                </div>
            </div>
        );
    }


    if (!feePlanData) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100 text-danger text-center impose-responsive-font">
                No fee plan details found for ID: {uniqueId}
            </div>
        );
    }

    const {
        specialization,
        semester,
        created_by,
        payments,
        students,
        total_amount,
        status,
        created_on,
    } = feePlanData;


    const handleApproval = async () => {
     

        try {
            const url = `finance/fee-schedules/verify-and-create/?signature=${encodeURIComponent(
                signature
            )}&user_id=${encodeURIComponent(user_id)}`;
            const payload = {
                unique_id: uniqueId,
                remark,
            };
            const response = await Postdata(url, payload);
            if (response.error) {
                Notifier.error(response.error);
                console.warn("API error details:", response.details);
                return;
            } else {
                navigate("/fee-approval-success", { state: { type: "impose" } });
                // Notifier.info(response.message || "Fee plan status updated");
            }
        } catch (error) {
            console.error("Error approving fee plan:", error);
            Notifier.error("Something went wrong while approving the fee plan");
        }
    };

    const handleCancel = async () => {
        try {
            const url = `finance/fee-schedules/reject/?signature=${encodeURIComponent(
                signature
            )}&user_id=${encodeURIComponent(user_id)}`;
            const payload = {
                unique_id: uniqueId,
                remark, 
            };
            const response = await Postdata(url, payload);
            if (response.error) {
                Notifier.error(response.error, response);
                return;
            }
            Notifier.success("Fee plan rejected successfully!");
            navigate("/fee-approval-cancel");
        } catch (error) {
            console.error("Error rejecting fee plan:", error);
            Notifier.error("Something went wrong while rejecting the fee plan");
        }
    };
    const toggleAccordion = () => {
        setIsAccordionOpen(!isAccordionOpen);
    };

    return (
        <>

            <div className="container py-4 impose-responsive-font">
                <h2 className="text-center mt-5 mb-4 impose-responsive-font templateFeeTitles">
                    Impose Fee Plan - Student-wise
                </h2>

                {/* Top Section */}
                <div className="row g-3 mb-4 mt-4 impose-responsive-font detailsContainer">
                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Course:</strong>
                        <div>{specialization.name} ({semester.name})</div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Status:</strong>
                        <div>
                            <span
                                className={`badge ${status === "pending_approval"
                                    ? "bg-warning text-dark"
                                    : status === "approved"
                                        ? "bg-success"
                                        : "bg-secondary"
                                    } impose-responsive-font badges`}

                            >
                                {status.replace("_", " ")}
                            </span>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Created By:</strong>
                        <div>{created_by}</div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Created On:</strong>
                        <div>{new Date(created_on).toLocaleString()}</div>
                    </div>
                </div>

                {/* Accordion Header */}
                <div
                    className="accordion-header d-flex justify-content-between align-items-center p-3 bg-light border rounded impose-accordion-header"
                    style={{ cursor: "pointer" }}
                    onClick={toggleAccordion}
                >
                    <h5 className="mb-0 impose-responsive-font">Students Fee Details</h5>
                    <span style={{ color: '#7F56DA', fontSize: '15px' }}>
                        {isAccordionOpen ? "▲" : "▼"}
                    </span>
                </div>

                {/* Accordion Content */}
                {isAccordionOpen && (
                    <div className="accordion-body mt-2">

                        <div className="table-responsive impose-table" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            <table className="table table-bordered text-center mb-0">
                                <thead className="table-light sticky-header">
                                    <tr>
                                        <th>#</th>
                                        <th className="text-start">Student Name / Reg No.</th>
                                        <th className="text-start">Fee Heads</th>
                                        <th className="text-end">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {students.map((stu, index) => {
                                        const studentTotal = stu.payments.reduce((sum, p) => sum + p.amount, 0);
                                        return (
                                            <tr key={stu.id}>
                                                <td>{index + 1}</td>
                                                <td className="text-start">
                                                    {stu.name} ({stu.rollNumber})
                                                </td>
                                                <td className="text-start">
                                                    {stu.payments.map((p, i) => (
                                                        <div key={i}>
                                                            {p.fee_head_name}
                                                            {i < stu.payments.length - 1 ? "," : ""}
                                                        </div>
                                                    ))}
                                                </td>
                                                <td className="text-end">
                                                    {stu.payments.map((p, i) => (
                                                        <div key={i}>₹{p.amount.toFixed(2)}</div>
                                                    ))}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                                <tfoot className="sticky-footer bg-light">
                                    <tr className="fw-bold">
                                        <td colSpan={3} className="text-start">Grand Total</td>
                                        <td className="text-end">
                                            ₹{students
                                                .map(stu => stu.payments.reduce((sum, p) => sum + p.amount, 0))
                                                .reduce((grandTotal, studentTotal) => grandTotal + studentTotal, 0)
                                                .toFixed(2)}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>



                    </div>
                )}

                {/* Remark & Buttons */}
                <div className="row g-3 align-items-end impose-buttons">
                    <div className="col-12 col-md-6">
                        {/* <label className="form-label impose-form-label">Remark</label>
                        <input
                            type="text"
                            id="remark"
                            className="form-control"
                            placeholder="Enter your remark"
                            value={remark}
                            onChange={(e) => setRemark(e.target.value)}
                        /> */}
                    </div>

                    <div className="col-12 col-md-6 d-flex justify-content-start justify-content-md-end align-items-center gap-2 btnContainers">
                        <button className="add-btn px-4" onClick={handleApproval}>
                            Approve
                        </button>
                        <button className="btn btn-secondary px-4" onClick={handleCancel}>
                            Cancel
                        </button>
                    </div>
                </div>
            </div>

        
        </>
    );
};

export default ImposeFeeApprovalsTemplateStudentWise;
